import { SET_FBCLID_SOURCE_TYPE } from 'actions';

export const setFbclidSourceType = (fbclid: string) => {
  return { fbclid, type: SET_FBCLID_SOURCE_TYPE };
};
